import { render, staticRenderFns } from "./AuthorDetails.vue?vue&type=template&id=3997ea40&"
import script from "./AuthorDetails.vue?vue&type=script&lang=js&"
export * from "./AuthorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports